/**
 * True for transport-level `fetch` failures — the request never produced an
 * HTTP response. On a backgrounded mobile WebView the OS cancels in-flight
 * requests, which surfaces as a `TypeError` ("Failed to fetch" on Android
 * Chromium; "The network connection was lost" / "cancelled" / "Load failed"
 * on iOS) or an `AbortError`. These are retryable; a non-`ok` HTTP response
 * (thrown as a plain `Error`) is a real failure and is not.
 */
const isTransientNetworkError = (error: unknown): boolean =>
  error instanceof TypeError ||
  (error instanceof DOMException && error.name === 'AbortError');

export default isTransientNetworkError;
